import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '../components/SeriousQuizPage.vue';
import axios from "axios";

axios.defaults.xsrfHeaderName = 'X-CSRFToken';
axios.defaults.xsrfCookieName = 'csrftoken';

const pinia = createPinia();

createApp(App)
  .use(pinia)
  .mount('#serious');
